import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import {Card, Tabs} from "antd";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";

export default function UserProfile() {

    return (
        <>
            <BaseLayout>
                <Card>
                    <Tabs type={'card'} defaultActiveKey={'Profile'}>
                        <Tabs.TabPane key={'Profile'} tab={'User Information'}>
                            <EditProfile />
                        </Tabs.TabPane>
                        <Tabs.TabPane key={'Change Password'} tab={'Change Password'}>
                            <ChangePassword />
                        </Tabs.TabPane>
                    </Tabs>
                </Card>
            </BaseLayout>
        </>
    )
}